export const LIST_ORDER_REQUEST = "LIST_ORDER_REQUEST";
export const LIST_ORDER_SUCCESS = "LIST_ORDER_SUCCESS";
export const LIST_ORDER_FAIL = "LIST_ORDER_FAIL";

export const ORDER_DETAILS_REQUEST = "ORDER_DETAILS_REQUEST";
export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL = "ORDER_DETAILS_FAIL";
